module.exports = __webpack_public_path__ + "media/images/cover/handshake-f844b792703baccb006c9df28c9994aa.jpg";